module.exports = __webpack_public_path__ + "static/media/IGO.ebe5ce6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/IGO.jpg
// module id = 1350
// module chunks = 1